import {State} from '../types/state'

export const isOwner = (state: State) => state.owner
